document.addEventListener('DOMContentLoaded', (event) => {
  const gameTiles = document.querySelectorAll('.tile')
  const gameBoard = document.querySelector('#game-board')
  const startGameBtn = document.querySelector('.start-game-btn')
  const endGameBtn = document.querySelector('.end-game-btn')
  const images = document.querySelectorAll('.tile img')
  const tiles = document.querySelectorAll('.tile')
  const alertsWrapper = document.querySelector('.game-alerts-wrapper')
  const alerts = document.querySelector('.game-alerts')
  const alertsText = document.querySelector('.game-alerts-text')
  const resetBtn = document.querySelector('.reset-btn')
  const game = document.querySelector('#game')

  const gameState = [
    [gameTiles[0], gameTiles[1], gameTiles[2]],
    [gameTiles[3], gameTiles[4], gameTiles[5]],
    [gameTiles[6], gameTiles[7], gameTiles[8]],
  ]
  // gameTiles.forEach((item, index) => {
  //     const img = <img src="img/puzz-2.jpg" alt="2"></img>

  //     item.innerHTML = img
  // })

  startGameBtn.addEventListener('click', function () {
    startWatch()

    let newArray = gameState

    newArray.map((item, index) => {
      for (let i = item.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[item[i], item[j]] = [item[j], item[i]]
      }
    })
    render(gameBoard, newArray)
    this.classList.add('hidden')
    resetBtn.classList.remove('hidden')
    resetBtn.classList.add('block')
    // endGameBtn.classList.add('active')
  })

  function checkImages(array) {
    const result = []
    array.map((item, index) => {
      item.forEach((img, imgIndex) => {
        if (index === 0 && parseInt(img.id) === imgIndex) {
          result.push(img)
        }
        if (index === 1 && parseInt(img.id - 3) === imgIndex) {
          result.push(img)
        }
        if (index === 2 && parseInt(img.id - 6) === imgIndex) {
          result.push(img)
        }
      })
    })

    const gameResult = document.querySelector('.stopwatch__content')
    const winDiv = document.querySelector('.win')
    if (result.length === 8) {
      gameResult.classList.add('text-green-500')
      winDiv.textContent = 'Congratulation!'
      stopWatch()
      const lastImg = document.createElement('img')
      lastImg.setAttribute('src', themeData.img + '/img/game/puzz-last.webp')
      if (gameTiles[0].children.length === 0) {
        gameTiles[0].appendChild(lastImg)
      }

      // const startBtn = document.createElement('button')
      // game.style.overflow = 'hidden'
      // const userResult = document.createElement('p')
      // startBtn.classList.add('actionBtn')
      // alertsWrapper.classList.add('show')
      // alerts.style.backgroundColor = 'green'
      // userResult.innerText = `Twój czas to:  ${hour.innerText} : ${minute.innerText} : ${seconde.innerText}`
      // userResult.style.color = '#fff'
      // alertsText.innerText = 'Gratulacja! Ułożyłeś cały obrazek'
      // startBtn.innerText = 'Zamknij'
      // alerts.appendChild(userResult)
      // alerts.appendChild(startBtn)
      // startBtn.addEventListener('click', function () {
      //   alertsWrapper.classList.remove('show')
      //   alerts.removeChild(startBtn)
      //   alerts.removeChild(userResult)
      //   game.style.overflow = 'auto'
      // })
    }
    // } else {
    //   // alert("Niestey nie ułożyłeś całego obrazka. Kontynuuj");
    //   const playBtn = document.createElement('button')
    //   game.style.overflow = 'hidden'
    //   playBtn.classList.add('actionBtn')
    //   alertsWrapper.classList.add('show')
    //   alerts.style.backgroundColor = 'rgb(141, 2, 2)'
    //   alertsText.innerText = 'Niestey nie ułożyłeś całego obrazka. Kontynuuj'
    //   playBtn.innerText = 'Kontynuuj'
    //   alerts.appendChild(playBtn)
    //   playBtn.addEventListener('click', function () {
    //     startWatch()
    //     alertsWrapper.classList.remove('show')
    //     alerts.removeChild(playBtn)
    //     game.style.overflow = 'auto'
    //   })
    // }
  }

  function render(gameBoard, gameState) {
    gameState.forEach((row, rowIndex) => {
      row.forEach((col, colIndex) => {
        if (window.innerWidth <= 1024) {
          col.style.top = `${rowIndex * 100}px`
          col.style.left = `${colIndex * 100}px`
          gameBoard.appendChild(col)
        } else {
          col.style.top = `${rowIndex * 200}px`
          col.style.left = `${colIndex * 200}px`
          gameBoard.appendChild(col)
        }
      })
    })
  }

  function moveElement(element1, element2) {
    const tempTop = element1.style.top
    const tempLeft = element1.style.left

    element1.style.top = element2.style.top
    element1.style.left = element2.style.left

    element2.style.top = tempTop
    element2.style.left = tempLeft
  }

  render(gameBoard, gameState)

  gameBoard.addEventListener('click', (e) => {
    const target = e.target
    checkImages(gameState)
    let x, y
    gameState.forEach((row, rowIndex) => {
      row.forEach((col, colIndex) => {
        if (col === target) {
          x = rowIndex
          y = colIndex
        }
      })
    })

    let emptyX, emptyY

    gameState.forEach((row, rowIndex) => {
      row.forEach((col, colIndex) => {
        if (col.innerHTML === '') {
          emptyX = rowIndex
          emptyY = colIndex
        }
      })
    })

    if (
      (y === emptyY && (x + 1 === emptyX || x - 1 === emptyX)) ||
      (x === emptyX && (y + 1 == emptyY || y - 1 === emptyY))
    ) {
      moveElement(gameState[x][y], gameState[emptyX][emptyY])

      let temp = gameState[x][y]
      gameState[x][y] = gameState[emptyX][emptyY]
      gameState[emptyX][emptyY] = temp
    }
  })
  // endGameBtn.addEventListener('click', () => checkImages(gameState))

  // TIMER

  //Variables
  const startBtn = document.querySelector('.stopwatch__start')

  const hourContent = document.getElementById('hour')
  const minuteContent = document.getElementById('minute')
  const secondeContent = document.getElementById('seconde')
  let watchInterval

  //Events
  eventListners()
  function eventListners() {
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        console.log('klik')
        resetWatch()
        location.reload()
      })
    }

    // if (endGameBtn) {
    //   endGameBtn.addEventListener('click', stopWatch)
    // }
  }

  //Functions
  function resetWatch() {
    hourContent.innerHTML = '00'
    minuteContent.innerHTML = '00'
    secondeContent.innerHTML = '00'
    stopWatch()
  }

  function startWatch() {
    gameBoard.classList.remove('pointer-events-none')
    let seconde = parseInt(secondeContent.textContent.trim())
    watchInterval = setInterval(() => {
      seconde += 1
      if (seconde == 60) {
        seconde = 0
        let minute = parseInt(minuteContent.textContent.trim())
        minute++
        if (minute == 60) {
          minute = 0
          let hour = parseInt(hourContent.textContent.trim())
          hour++
          if (hour == 24) {
            hour = 0
          }
          if (hour < 10) {
            hourContent.innerHTML = '0' + hour
          } else {
            hourContent.innerHTML = hour
          }
        }
        if (minute < 10) {
          minuteContent.innerHTML = '0' + minute
        } else {
          minuteContent.innerHTML = minute
        }
      }
      if (seconde < 10) {
        secondeContent.innerHTML = '0' + seconde
      } else {
        secondeContent.innerHTML = seconde
      }
    }, 1000)
  }

  function stopWatch() {
    if (watchInterval) {
      clearInterval(watchInterval)
    }
  }
})
